import { render, staticRenderFns } from "./PrefPicker.vue?vue&type=template&id=a9e0a658&scoped=true"
import script from "./PrefPicker.vue?vue&type=script&lang=js"
export * from "./PrefPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e0a658",
  null
  
)

export default component.exports